export const EmailHasher = {
  async sha256Hex(email) {
    if (!email) {
      return null;
    }

    if (typeof crypto === "undefined" || !crypto.subtle) {
      return null;
    }

    try {
      const encoder = new TextEncoder();
      const data = encoder.encode(email.trim().toLowerCase());
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);

      const view = new DataView(hashBuffer);
      let hex = "";
      for (let i = 0; i < view.byteLength; i++) {
        hex += view.getUint8(i).toString(16).padStart(2, "0");
      }

      return hex;
    } catch (e) {
      console.error("Failed to hash email", e);
      return null;
    }
  },
};
